// Lightweight global theme controller (light / dark).
// Dark mode is applied to <body> via the `theme-dark` class and persisted
// in localStorage. The login pages are NOT wrapped in .workspace-layout, so
// the dark styles (scoped to .workspace-layout) never affect them.

const STORAGE_KEY = 'vetobase-theme';

export const getTheme = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
};

export const applyTheme = (theme) => {
  const dark = theme === 'dark';
  document.body.classList.toggle('theme-dark', dark);
  // Notify listeners (e.g. the toggle UI) so they can re-render.
  window.dispatchEvent(new CustomEvent('themechange', { detail: { theme: dark ? 'dark' : 'light' } }));
};

export const setTheme = (theme) => {
  const value = theme === 'dark' ? 'dark' : 'light';
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {}
  applyTheme(value);
  return value;
};

export const toggleTheme = () => setTheme(getTheme() === 'dark' ? 'light' : 'dark');
